/* eslint-disable no-console */
import { AnalysisType } from "@iventis/domain-model/model/analysisType";
import { MetricName } from "@iventis/domain-model/model/metricName";
import { incrementMonitoringCount } from "../set-monitoring-metric";
import { MetricEvent } from "../metric-types";

export function analysisToolMonitoringMetric(analysisType: AnalysisType, event: Partial<MetricEvent> = {}) {
    switch (analysisType) {
        case AnalysisType.Distance:
            incrementMonitoringCount({ ...event, name: MetricName.DISTANCE_ANALYSIS_USED });
            break;
        case AnalysisType.WalkTime:
            incrementMonitoringCount({ ...event, name: MetricName.WALK_TIME_ANALYSIS_USED });
            break;
        case AnalysisType.FlowRate:
            incrementMonitoringCount({ ...event, name: MetricName.FLOW_RATE_ANALYSIS_USED });
            break;
        case AnalysisType.Area:
            incrementMonitoringCount({ ...event, name: MetricName.AREA_ANALYSIS_USED });
            break;
        case AnalysisType.Capacity:
            incrementMonitoringCount({ ...event, name: MetricName.CAPACITY_ANALYSIS_USED });
            break;
        case AnalysisType.Count:
            incrementMonitoringCount({ ...event, name: MetricName.COUNT_ANALYSIS_USED });
            break;
        default:
            console.warn(`Analysis type ${analysisType} is not supported for monitoring`);
    }
}
